import { useEffect, useState } from 'react';
import AdminLayout from '../AdminLayout';
import { getGalleryItems, addGalleryItem, deleteGalleryItem } from '../../services/adminService';
import { uploadToCloudinary } from '../../utils/uploadToCloudinary';

const GALLERIES = [
  { key: 'bridal_images', label: 'Bridal' },
  { key: 'party_images', label: 'Party' },
  { key: 'editorial_images', label: 'Editorial' },
  { key: 'groom_images', label: 'Groom' },
  { key: 'course_images', label: 'Courses' },
];

function GalleryTab({ colName }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [uploading, setUploading] = useState(false);

  const load = () => getGalleryItems(colName).then(d => { setItems(d); setLoading(false); });
  useEffect(() => { load(); }, [colName]);

  const handleFile = async (e) => {
    const files = Array.from(e.target.files);
    if (!files.length) return;
    setUploading(true);
    try {
      for (const file of files) {
        const url = await uploadToCloudinary(file);
        await addGalleryItem(colName, { image: url, order: items.length });
      }
      await load();
    } catch { alert('Upload failed'); }
    finally { setUploading(false); e.target.value = ''; }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Remove this image?')) return;
    await deleteGalleryItem(colName, id);
    setItems(prev => prev.filter(i => i.id !== id));
  };

  if (loading) return <div className="admin-spinner">Loading…</div>;

  return (
    <div>
      <div style={{ marginBottom: 20 }}>
        <label className="a-btn a-btn-accent" style={{ cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: 6 }}>
          {uploading ? 'Uploading…' : '+ Upload Images'}
          <input type="file" accept="image/*" multiple onChange={handleFile} style={{ display: 'none' }} disabled={uploading} />
        </label>
        <span style={{ marginLeft: 12, fontSize: 13, color: 'var(--a-text-muted)' }}>{items.length} images</span>
      </div>
      {items.length === 0 ? <div className="admin-empty">No images yet. Upload some above.</div> : (
        <div className="admin-gallery-grid">
          {items.map(item => (
            <div key={item.id} className="admin-gallery-item">
              <img src={item.image} alt="" />
              <div className="delete-overlay">
                <button onClick={() => handleDelete(item.id)}>Remove</button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default function AdminGalleries() {
  const [tab, setTab] = useState(0);

  return (
    <AdminLayout title="Service Galleries">
      <div className="admin-tabs">
        {GALLERIES.map((g, i) => (
          <button key={g.key} className={`admin-tab${tab === i ? ' active' : ''}`} onClick={() => setTab(i)}>
            {g.label}
          </button>
        ))}
      </div>
      <div className="admin-section">
        <div className="admin-section-header"><h2>{GALLERIES[tab].label} Gallery</h2></div>
        <div className="admin-section-body">
          <GalleryTab key={GALLERIES[tab].key} colName={GALLERIES[tab].key} />
        </div>
      </div>
    </AdminLayout>
  );
}
